import { formatSurface } from '../../../../common-utils/formatters';

export const SURFACE_THRESHOLD = 20;
export const FLOOR_THRESHOLD = 3; // 3 meters per floor
export const ATTIC_THRESHOLD = 2.5; // 2.5 meters for attic
export const ATTIC_STANDARDS = {
  30: { atticSurface: 37.6, perimeter: 40 },
  50: { atticSurface: 69.8, perimeter: 40 },
};

export const ROOF_TYPE_MAP = {
  ne_pas_utiliser: null,
  ardoise: 1,
  tuile: 2,
  autre: 3,
};

export const ROOF_TYPE_REVERSE_MAP = {
  1: 'ardoise',
  2: 'tuile',
  3: 'autre',
};

export const getSurfaceWithoutWallsThickness = (building) => {
  const emprise = parseFloat(building.emprise) || 0;
  const perimetre = parseFloat(building.perimetre) || 0;
  return emprise - (perimetre * (30 / 100));
};

export const getConstructionHeight = (building) => {
  let heightFactor = 'Default';
  let constructionHeight = 0;

  if (building.altitudeMaximaleToit != null && building.altitudeMaximaleSol != null) {
    heightFactor = 'Faitage';
    constructionHeight = (parseFloat(building.altitudeMaximaleToit) || 0) - (parseFloat(building.altitudeMaximaleSol) || 0);
  } else if (building.altitudeMinimaleToit != null && building.altitudeMaximaleSol != null) {
    heightFactor = 'Gouttière';
    constructionHeight = (parseFloat(building.altitudeMinimaleToit) || 0) - (parseFloat(building.altitudeMaximaleSol) || 0);
  } else if (building.hauteur != null) {
    heightFactor = 'Déclaration';
    constructionHeight = parseFloat(building.hauteur) || 0;
  }

  return { Facteur: heightFactor, Hauteur: constructionHeight };
};

export const calculateAdjustedEstimation = (building, floorCountValue, roofTypeValue) => {
  if (parseFloat(building.emprise) <= SURFACE_THRESHOLD) {
    return {
      habitableHorsCombles: 0,
      nbNiveaux: 0,
      habitableComblesMin: 0,
      habitableComblesMax: 0,
      habitableComblesMoy: 0,
      totalHabitableMin: 0,
      totalHabitableMax: 0,
      totalHabitableAvg: 0,
    };
  }

  const surfaceWithoutWallsThickness = getSurfaceWithoutWallsThickness(building);
  const heightDetails = getConstructionHeight(building);
  const height = heightDetails.Hauteur;
  const heightFactor = heightDetails.Facteur;
  const perimetre = parseFloat(building.perimetre) || 0;

  let floorsCount = Math.max(Math.floor(height / FLOOR_THRESHOLD), 1);
  const nombreDetages = parseInt(floorCountValue, 10) || parseInt(building.nombreDEtages, 10);

  if (nombreDetages && nombreDetages > 0) {
    floorsCount = nombreDetages;
  }

  const remainingHeight = height - (floorsCount * FLOOR_THRESHOLD);
  let isLastLevelUnderRoof = 0;

  if ((heightFactor === 'Faitage' && remainingHeight < ATTIC_THRESHOLD && floorsCount > 1) || roofTypeValue === 'tuile') {
    isLastLevelUnderRoof = 1;
  } else if (remainingHeight >= ATTIC_THRESHOLD) {
    // TODO : discuss this pseudo fix since it is just for user experience but not accurate
    floorsCount += 1;
  }

  const surfaceWithoutLastLevel = surfaceWithoutWallsThickness * (floorsCount - isLastLevelUnderRoof);

  let atticMinSurface; let atticMaxSurface; let
    atticAvgSurface;

  if (floorsCount < 6) {
    atticMinSurface = perimetre * ATTIC_STANDARDS['30'].atticSurface / ATTIC_STANDARDS['30'].perimeter;
    atticMaxSurface = perimetre * ATTIC_STANDARDS['50'].atticSurface / ATTIC_STANDARDS['50'].perimeter;
    atticAvgSurface = (atticMinSurface + atticMaxSurface) / 2;
  } else {
    atticMinSurface = atticMaxSurface = atticAvgSurface = surfaceWithoutWallsThickness;
  }

  const totalHabitableMin = surfaceWithoutLastLevel + atticMinSurface;
  const totalHabitableMax = surfaceWithoutLastLevel + atticMaxSurface;
  const totalHabitableAvg = surfaceWithoutLastLevel + atticAvgSurface;

  return {
    surfaceWithoutWallsThickness,
    heightFactor,
    height,
    habitableHorsCombles: surfaceWithoutLastLevel,
    nbNiveaux: floorsCount,
    habitableComblesMin: atticMinSurface,
    habitableComblesMax: atticMaxSurface,
    habitableComblesMoy: atticAvgSurface,
    totalHabitableMin,
    totalHabitableMax,
    totalHabitableAvg,
  };
};

export const calculateTotalSurface = (copro, returnNumber = false) => {
  const validatedSurface = copro.batiments
    .filter((building) => building.isValidatedByUser === true)
    .reduce((sum, building) => sum + (parseFloat(building.realSurface) || 0), 0);
  return returnNumber ? validatedSurface : formatSurface(validatedSurface);
};

export const calculateValidatedBuildings = (copro) => copro.batiments.filter((building) => building.isValidatedByUser === true).length;
